"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPayloadForExit = exports.encodePayload = exports.ERC1155_TRANSFER_BATCH_EVENT_SIG = exports.ERC1155_TRANSFER_SINGLE_EVENT_SIG = exports.ERC721_TRANSFER_EVENT_SIG = exports.ERC20_TRANSFER_EVENT_SIG = void 0;
var bytes_1 = require("@ethersproject/bytes");
var ethereumjs_util_1 = require("ethereumjs-util");
var blockProof_1 = require("./proofs/blockProof");
var receiptProof_1 = require("./proofs/receiptProof");
var logIndex_1 = require("./utils/logIndex");
var buffer_1 = require("./utils/buffer");
var blockProof_2 = require("./proofs/blockProof");
Object.defineProperty(exports, "buildBlockProof", { enumerable: true, get: function () { return blockProof_2.buildBlockProof; } });
var receiptProof_2 = require("./proofs/receiptProof");
Object.defineProperty(exports, "buildReceiptProof", { enumerable: true, get: function () { return receiptProof_2.buildReceiptProof; } });
Object.defineProperty(exports, "getReceiptBytes", { enumerable: true, get: function () { return receiptProof_2.getReceiptBytes; } });
var checks_1 = require("./checks");
Object.defineProperty(exports, "isBlockCheckpointed", { enumerable: true, get: function () { return checks_1.isBlockCheckpointed; } });
Object.defineProperty(exports, "isBurnTxCheckpointed", { enumerable: true, get: function () { return checks_1.isBurnTxCheckpointed; } });
Object.defineProperty(exports, "isBurnTxProcessed", { enumerable: true, get: function () { return checks_1.isBurnTxProcessed; } });
Object.defineProperty(exports, "isBurnTxClaimable", { enumerable: true, get: function () { return checks_1.isBurnTxClaimable; } });
exports.ERC20_TRANSFER_EVENT_SIG = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
exports.ERC721_TRANSFER_EVENT_SIG = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
exports.ERC1155_TRANSFER_SINGLE_EVENT_SIG = "0xc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62";
exports.ERC1155_TRANSFER_BATCH_EVENT_SIG = "0x4a39dc06d4c0dbc64b70af90fd698a233a518aa5d07e595d983b8c0526c8f7fb";
exports.encodePayload = function (_a) {
    var headerBlockNumber = _a.headerBlockNumber, blockProof = _a.blockProof, burnTxBlockNumber = _a.burnTxBlockNumber, burnTxBlockTimestamp = _a.burnTxBlockTimestamp, transactionsRoot = _a.transactionsRoot, receiptsRoot = _a.receiptsRoot, receipt = _a.receipt, receiptProofParentNodes = _a.receiptProofParentNodes, receiptProofPath = _a.receiptProofPath, logIndex = _a.logIndex;
    return ethereumjs_util_1.bufferToHex(ethereumjs_util_1.rlp.encode([
        headerBlockNumber,
        bytes_1.hexConcat(blockProof),
        burnTxBlockNumber,
        burnTxBlockTimestamp,
        transactionsRoot,
        receiptsRoot,
        receiptProof_1.getReceiptBytes(receipt),
        // Each node in proof has been RLP encoded when serialised
        // so we need to decode each individually and reencode the proof as a whole
        ethereumjs_util_1.rlp.encode(receiptProofParentNodes.map(function (node) { return ethereumjs_util_1.rlp.decode(buffer_1.hexToBuffer(node)); })),
        receiptProofPath,
        logIndex,
    ]));
};
exports.buildPayloadForExit = function (rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxHash, logEventSigOrIndex) { return __awaiter(void 0, void 0, void 0, function () {
    var burnTxReceipt, logIndex, _a, receipt, receiptProof, _b, burnTxBlockNumber, burnTxBlockTimestamp, transactionsRoot, receiptsRoot, headerBlockNumber, blockProof;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, maticChainProvider.getTransactionReceipt(burnTxHash)];
            case 1:
                burnTxReceipt = _c.sent();
                if (typeof burnTxReceipt === null) {
                    throw new Error("Could not find transaction corresponding to burnTxHash");
                }
                else if (typeof burnTxReceipt.blockNumber === "undefined") {
                    throw new Error("Could not find blocknumber of burnTx");
                }
                else if (typeof burnTxReceipt.blockHash === "undefined") {
                    throw new Error("Could not find blockHash of burnTx");
                }
                logIndex = typeof logEventSigOrIndex === "string" ? logIndex_1.getLogIndex(burnTxReceipt, logEventSigOrIndex) : logEventSigOrIndex;
                return [4 /*yield*/, receiptProof_1.buildReceiptProof(maticChainProvider, burnTxHash)];
            case 2:
                _a = _c.sent(), receipt = _a.receipt, receiptProof = _a.receiptProof;
                return [4 /*yield*/, blockProof_1.buildBlockProof(rootChainProvider, maticChainProvider, rootChainContractAddress, burnTxReceipt.blockNumber)];
            case 3:
                _b = _c.sent(), burnTxBlockNumber = _b.burnTxBlockNumber, burnTxBlockTimestamp = _b.burnTxBlockTimestamp, transactionsRoot = _b.transactionsRoot, receiptsRoot = _b.receiptsRoot, headerBlockNumber = _b.headerBlockNumber, blockProof = _b.blockProof;
                return [2 /*return*/, {
                        headerBlockNumber: headerBlockNumber,
                        blockProof: blockProof,
                        burnTxBlockNumber: burnTxBlockNumber,
                        burnTxBlockTimestamp: burnTxBlockTimestamp,
                        transactionsRoot: transactionsRoot,
                        receiptsRoot: receiptsRoot,
                        receipt: receipt,
                        receiptProofParentNodes: receiptProof.parentNodes,
                        receiptProofPath: receiptProof.path,
                        logIndex: logIndex,
                    }];
        }
    });
}); };
